import { Instagram, Mail, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { LOGO_URL, SOCIAL } from "@/data/sponsors";
import { BCNEXT_URL } from "@/components/TopBar";

export const Footer = () => (
  <footer className="border-t border-[#E8E2E4] bg-white" data-testid="site-footer">
    <div className="mx-auto grid max-w-[1400px] gap-10 px-5 py-14 sm:px-10 md:grid-cols-4">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3">
          <img
            src={LOGO_URL}
            alt="Logo DonnaImpresa"
            className="h-11 w-11 rounded-xl object-cover"
          />
          <span className="font-display text-xl text-[#1A1617]">
            Donna<span className="text-[#E0708A]">Impresa</span>
          </span>
        </div>
        <p className="mt-5 max-w-sm text-sm leading-relaxed text-[#6B5E62]">
          La community che dà voce, spazio e visibilità alle imprese guidate da
          donne. Storie che diventano linee guida per altre.
        </p>
        <p className="mt-3 max-w-sm text-xs leading-relaxed text-[#9B8F92]">
          Donna Impresa — rete di donne in impresa e donne imprenditrici in
          tutta Italia.
        </p>
      </div>

      <div>
        <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-[#5E2A52]">
          Naviga
        </h3>
        <div className="mt-5 flex flex-col gap-3 text-sm text-[#6B5E62]">
          <Link to="/donna-impresa" className="di-underline w-fit" data-testid="footer-guida-link">
            Guida Donna Impresa
          </Link>
          <Link to="/manifesto" className="di-underline w-fit" data-testid="footer-manifesto-link">Manifesto</Link>
          <Link to="/community" className="di-underline w-fit" data-testid="footer-community-link">
            Community
          </Link>
          <Link to="/sponsor" className="di-underline w-fit" data-testid="footer-sponsor-link">Sponsor</Link>
          <Link to="/social" className="di-underline w-fit" data-testid="footer-social-link">Instagram</Link>
          <Link to="/partner" className="di-underline w-fit" data-testid="footer-partner-link">Partner BC Next</Link>
          <Link to="/racconta-la-tua-storia" className="di-underline w-fit" data-testid="footer-story-link">
            Raccontaci la tua storia
          </Link>
          <Link to="/privacy" className="di-underline w-fit" data-testid="footer-privacy-link">
            Privacy policy
          </Link>
          <Link to="/cookie-policy" className="di-underline w-fit" data-testid="footer-cookie-link">
            Cookie policy
          </Link>
        </div>
      </div>

      <div>
        <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-[#5E2A52]">
          Seguici
        </h3>
        <div className="mt-5 flex gap-3">
          <a
            href={SOCIAL.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-instagram"
            aria-label="Instagram"
            className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-[#E8E2E4] text-[#5E2A52] transition-colors duration-300 hover:border-[#E0708A] hover:text-[#E0708A]"
          >
            <Instagram size={18} />
          </a>
          <a
            href="mailto:impresahub@gmail.com"
            data-testid="footer-email"
            aria-label="Email"
            className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-[#E8E2E4] text-[#5E2A52] transition-colors duration-300 hover:border-[#E0708A] hover:text-[#E0708A]"
          >
            <Mail size={18} />
          </a>
        </div>
        <a
          href="mailto:impresahub@gmail.com"
          data-testid="footer-email-text"
          className="mt-5 inline-block text-sm text-[#6B5E62] transition-colors duration-300 hover:text-[#E0708A]"
        >
          impresahub@gmail.com
        </a>
      </div>
    </div>

    <a
      href={BCNEXT_URL}
      target="_blank"
      rel="noreferrer"
      data-testid="bcnext-footer-band"
      className="group block border-t border-[#E8E2E4] bg-[#5E2A52]"
    >
      <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-between gap-4 px-5 py-8 sm:px-10">
        <div>
          <p className="text-[11px] uppercase tracking-[0.28em] text-white/55">
            Progetto realizzato da
          </p>
          <p className="mt-2 font-display text-3xl tracking-tight text-white">
            BC NEXT{" "}
            <span className="text-lg font-normal text-[#E0708A]">
              IT Consulting
            </span>
          </p>
          <p className="mt-1 text-sm text-white/60">
            Soluzioni digitali, piattaforme e formazione
          </p>
        </div>
        <span className="inline-flex items-center gap-2 rounded-full border border-white/25 px-6 py-3 text-sm font-semibold text-white transition-colors duration-300 group-hover:bg-white group-hover:text-[#5E2A52]">
          bcnext.it
          <ArrowUpRight size={15} />
        </span>
      </div>
    </a>

    <div className="border-t border-[#E8E2E4] px-5 py-6 text-center text-xs text-[#6B5E62] sm:px-10">
      © {new Date().getFullYear()} DonnaImpresa — Tutti i diritti riservati
    </div>
  </footer>
);
